module.exports = __webpack_public_path__ + "custom-config/img/tips@2x.a102335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/msgbox/tips@2x.png
// module id = ranQ
// module chunks = 2 3 4 6 7 8 9